import CONSTANTS from '../constants'
import { downloadFile, getRequest, postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'


export const getFaciltyData = () => (dispatch) => {
    dispatch(addEventLog('', CONSTANTS.GET_FACILITY_RATE_REQUEST))
    dispatch({ type: CONSTANTS.GET_FACILITY_RATE_REQUEST })
    return getRequest(APICONFIG.getPartnerDetails).then((res) => {
        dispatch(addEventLog(res, CONSTANTS.GET_FACILITY_RATE_SUCCESS))
        dispatch({ type: CONSTANTS.GET_FACILITY_RATE_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch(addEventLog(err, CONSTANTS.GET_FACILITY_RATE_FAILURE))
        dispatch({ type: CONSTANTS.GET_FACILITY_RATE_FAILURE })
        return err
    })
}

// // Calls the API to get user token
// export const userDetails = (creds) => (dispatch) => {
//     dispatch({ type: CONSTANTS.USER_DETAILS_REQUEST })
//     return postRequest(APICONFIG.getUserDetailUrl, creds).then((res) => {
//         dispatch({ type: CONSTANTS.USER_DETAILS_SUCCESS, data: res })
//         return res
//     }).catch((err) => {
//         dispatch({ type: CONSTANTS.USER_DETAILS_FAILURE })
//         return err
//     })
// }
// Calls the API to get user token
export const userDetails = (creds) => (dispatch) => {
    let payload = {...creds, 'device_type': 'web'}
    dispatch(addEventLog(payload, CONSTANTS.USER_DETAILS_REQUEST))
    dispatch({ type: CONSTANTS.USER_DETAILS_REQUEST })
    return postRequest(APICONFIG.getSearchUrl, payload).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.USER_DETAILS_SUCCESS))
        dispatch({ type: CONSTANTS.USER_DETAILS_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.USER_DETAILS_FAILURE))
        dispatch({ type: CONSTANTS.USER_DETAILS_FAILURE })
        return err
    })
}

export const sendSmsEmail = (creds) => (dispatch) => {
    let payload = {...creds, 'device_type': 'web'}
    dispatch(addEventLog(payload, CONSTANTS.SMS_EMAIL_REQUEST))
    dispatch({ type: CONSTANTS.SMS_EMAIL_REQUEST })
    return postRequest(APICONFIG.sendSmsEmailUrl, payload).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.SMS_EMAIL_SUCCESS))
        dispatch({ type: CONSTANTS.SMS_EMAIL_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.SMS_EMAIL_FAILURE))
        dispatch({ type: CONSTANTS.SMS_EMAIL_FAILURE })
        return err
    })
}

export const downloadTicket = (payload) => (dispatch) => {
    dispatch(addEventLog(payload, CONSTANTS.DOWNLOAD_TICKET_REQUEST))
    dispatch({ type: CONSTANTS.DOWNLOAD_TICKET_REQUEST })
    return downloadFile(`${APICONFIG.downloadEticketUrl}/${payload}`, payload, `${payload ? payload : 'ticket'}.pdf`).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.DOWNLOAD_TICKET_SUCCESS))
        dispatch({ type: CONSTANTS.DOWNLOAD_TICKET_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.DOWNLOAD_TICKET_FAILURE))
        dispatch({ type: CONSTANTS.DOWNLOAD_TICKET_FAILURE })
        return err
    })
}


// Calls the API to fetch Ticket Details
export const getTicketDetails = (payload) => (dispatch) => {
    let payloadTicket = {...payload, 'device_type': 'web'}
    dispatch(addEventLog(payloadTicket, CONSTANTS.GET_TICKET_DETAILS_REQUEST))
    dispatch({ type: CONSTANTS.GET_TICKET_DETAILS_REQUEST })
    return postRequest(APICONFIG.getSearchTicketUrl, payloadTicket).then((res) => {
        let resObject = { ...payloadTicket, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.GET_TICKET_DETAILS_SUCCESS))
        dispatch({ type: CONSTANTS.GET_TICKET_DETAILS_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payloadTicket, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.GET_TICKET_DETAILS_FAILURE))
        dispatch({ type: CONSTANTS.GET_TICKET_DETAILS_FAILURE, errorMessage: err?.errors?.message })
        return err
    })
}


// updated user-Profile
export const updateUserProfile = (data) => (dispatch) => {
    let payload = {...data, 'device_type': 'web'}
    dispatch(addEventLog(payload, CONSTANTS.UPDATE_USER_PROFILE_REQUEST))
    dispatch({ type: CONSTANTS.UPDATE_USER_PROFILE_REQUEST })
    return postRequest(APICONFIG.updateUserProfileUrl, payload).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.UPDATE_USER_PROFILE_SUCCESS))
        dispatch({ type: CONSTANTS.UPDATE_USER_PROFILE_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.UPDATE_USER_PROFILE_FAILURE))
        dispatch({ type: CONSTANTS.UPDATE_USER_PROFILE_FAILURE })
        return err
    })
}

export const getUserProfile = () => (dispatch) => {
    dispatch(addEventLog('', CONSTANTS.GET_USER_PROFILE_REQUEST))
    dispatch({ type: CONSTANTS.GET_USER_PROFILE_REQUEST })
    return getRequest(APICONFIG.getUserProfileUrl).then((res) => {
        dispatch(addEventLog(res, CONSTANTS.GET_USER_PROFILE_SUCCESS))
        dispatch({ type: CONSTANTS.GET_USER_PROFILE_SUCCESS, data: res.data })
        return res.data
    }).catch((err) => {
        dispatch(addEventLog(err, CONSTANTS.GET_USER_PROFILE_FAILURE))
        dispatch({ type: CONSTANTS.GET_USER_PROFILE_FAILURE })
    })
}

export const postRestPassword = (payload) => dispatch => {
    let payloadResPass = {...payload, 'device_type': 'web'}
    dispatch(addEventLog(payloadResPass, CONSTANTS.POST_RESET_PASSWORD_REQUEST))
    dispatch({ type: CONSTANTS.POST_RESET_PASSWORD_REQUEST })
    return postRequest(APICONFIG.postRestPassword, payloadResPass).then((res) => {
        let resObject = { ...payloadResPass, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.POST_RESET_PASSWORD_SUCCESS))
        dispatch({ type: CONSTANTS.POST_RESET_PASSWORD_SUCCESS, data: res.data })
        return res
    }).catch((err) => {
        let errObject = { ...payloadResPass, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.POST_RESET_PASSWORD_FAILURE))
        dispatch({ type: CONSTANTS.POST_RESET_PASSWORD_FAILURE })
        return err
    })
}


// GET PARTNER BY SLUG
export const getPartnerDetailsBySLug = (slug) => (dispatch) => {
    dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_REQUEST })
    return getRequest(`${APICONFIG.getPartnerBySlug}/${slug}`).then((res) => {
        dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_SUCCESS, data: res })
        return res
    }).catch((err) => {
        dispatch({ type: CONSTANTS.GET_PARTNER_DETAILS_BY_SLUG_FAILURE, errorMessage: err })
        return err
    })
}

